<main class="mb-4" *ngIf="isCommonDataLoaded">
  <label for="Campos obrigatórios" style="color:#DB3347"><span class="mandatory"></span>{{'Workflow.Mandatory' | translate}}</label>
  <div class="col-sm-12">
    <h1 class="text-primary mb-4">{{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Title' | translate}}</h1>
  </div>

  <div class="row ">
    <div class="col-sm-12">
      <h2 class="text-primary mt-3">{{'PrestacoesMorte.StepSender.Cards.SenderIdentification.SubTitle' | translate}}</h2>
    </div>
  </div>

  <div class="row ">

    <!--Nome-->
    <div class="col-sm-8">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('name')" required>
          <label for="name" [class.disabled]="isFieldDisabled('name')"><span class="mandatory">*</span>{{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Fields.Name' | translate}}</label>
          <div class="position-relative">
            <input class="form-control input-right" type="text" [(ngModel)]="model.name"
                   #name="ngModel" name="name"
                   maxlength="60"
                   placeholder="{{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Fields.NamePlaceholder' | translate}}"
                   messageFieldType="string">

            <validation-message [control]="name"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>

    <!--Data de Nascimento-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('dateOfBirth')" required>
          <label for="dateOfBirth"  [class.disabled]="isFieldDisabled('dateOfBirth')">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Fields.DateOfBirth' | translate}}
          </label>
          <div class="form-row">
            <div class="input-group col-sm-12">
              <input #dpDateOfBirth="bsDatepicker" bsDatepicker type="text" autocomplete="off" class="form-control DatepickerCustomClasse"
                     placeholder="{{'Placeholders.Generic.DateFormat' | translate}}"
                     [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', containerClass: 'theme-default', showWeekNumbers:false }"
                     [(ngModel)]="model.dateOfBirth" name="dateOfBirth"
                     [maxDate]="maxDate"
                     maxlength="10" 
                     #dateOfBirth="ngModel"
                     (keyup)="formatDate($event)" (keydown)="onlyNumbers($event)" (change)="onDateChange($event, dpDateOfBirth)"/>
              <div class="input-group-append disable-on-fieldset" (click)="!dpDateOfBirth.isDisabled && dpDateOfBirth.toggle()">
                <span class="input-group-text" id="basic-addon2">
                  <i class="icon-calendar"></i>
                </span>
              </div>
              <validation-message [control]="dateOfBirth"></validation-message>
            </div>
          </div>
        </fieldset>
      </div>

    </div>
  </div>


  <div class="row">

    <!--Tem nacionalidade portuguesa?-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('hasNacPT')">
          <label for="hasPortugueseNationality" [class.disabled]="isFieldDisabled('hasNacPT')">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNationality' | translate}}
          </label>
          <div class="btn-group btn-group-toggle maxWidth">
            <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle"
                   [class.active]="domain.value==model.hasNacPT?.toString()"
                   [radioLabel]="hasPortugueseNationality">
              <input type="radio"
                     [(ngModel)]="model.hasNacPT"
                     [clearRelated]="{model : this.model , propsToReset : ['identificationNumberFirst','identificationNumberLast']}"
                     name="hasPortugueseNationality"
                     (change)="hasPortugueseNationalityChange(model.hasNacPT)"
                     #hasLegalRepresentation="ngModel"
                     [value]="domain.value">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
            <!--<span>model.hasNacPT:{{model.hasNacPT}}</span>-->
          </div>
        </fieldset>
      </div>
    </div>

    <!--Genero-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('gender') && !isEditable">
          <label for="Gender" [class.disabled]="isFieldDisabled('gender') && !isEditable">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.Gender' | translate}}
          </label>
          <select class="custom-select"
                  [(ngModel)]="model.gender"
                  name="gender"
                  #gender="ngModel"
                  required
                  [dropdownTitle]="{value : model.gender, dimensions :  genders }"
                  nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of genders" [value]="domain.code">
              {{domain.description}}
            </option>
          </select>
          <validation-message [control]="gender"></validation-message>
        </fieldset>
      </div>
    </div>

    <!--Estado civil na data do óbito-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('civilState') && !isEditable">
          <label for="MaritalStatus" [class.disabled]="isFieldDisabled('civilState') && !isEditable">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.CivilState' | translate}}
          </label>
          <select class="custom-select"
                  [(ngModel)]="model.civilState"
                  name="civilState"
                  #civilState="ngModel"
                  required
                  nullableSelect>
            <default-dropdown-values></default-dropdown-values>
            <option *ngFor="let domain of maritalStatus" [value]="domain.description">
              {{domain.value}}
            </option>
          </select>
          <validation-message [control]="civilState"></validation-message>
        </fieldset>
      </div>
    </div>


  </div>



  <div class="row">
    <!--Tipo de documento de identificação-->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="DocumentType" [class.disabled]="model.hasNacPT!= null && model.hasNacPT!=undefined">
          <span class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.IdentificationDocumentType' | translate}}
        </label>
        <select class="custom-select"
                [(ngModel)]="model.identificationDocumentType"
                name="identificationDocumentType"
                #identificationDocumentType="ngModel"
                [disabled]="model.hasNacPT!= null && model.hasNacPT!=undefined"
                required
                [dropdownTitle]="{value : model.identificationDocumentType, dimensions : documentTypes }"
                nullableSelect>
          <default-dropdown-values></default-dropdown-values>
          <option *ngFor="let domain of documentTypes" [value]="domain.code">
            {{domain.description}}
          </option>
        </select>
        <validation-message [control]="identificationDocumentType"></validation-message>
      </div>
    </div>

    <!--Número de identificação-->
    <div class="col-sm-4">
      <div class="form-group">
        <label for="identificationNumber"
               [ngClass]="isFieldDisabled('identificationNumberFirst') ? 'disabled' : ''">
          <span class="mandatory">*</span>
          {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.IdentificationNumber' | translate}}
        </label>
        <div class="form-row">
          @if(model.identificationDocumentType !='P' ){

          <div class="col-sm-9">
            <input class="form-control"
                   type="text"
                   numeric="8"
                   required
                   [disabled]="isFieldDisabled('identificationNumberFirst')"
                   [(ngModel)]="model.identificationNumberFirst"
                   name="identificationNumberFirst"
                   #identificationNumberFirst="ngModel"
                   maxlength="8">
          </div>
          }
          @else {
          <div class="col-sm-9">
            <input class="form-control"
                   type="text"
                   required
                   mask="A*"
                   [disabled]="isFieldDisabled('identificationNumberFirst')"
                   [(ngModel)]="model.identificationNumberFirst"
                   name="identificationNumberFirst"
                   #identificationNumberFirst="ngModel"
                   maxlength="10">
          </div>
          }
          <div class="col-sm-3">
            <input class="form-control"
                   type="text"
                   maxlength="4"
                   [(ngModel)]="model.identificationNumberLast"
                   [disabled]="isFieldDisabled('identificationNumberLast') || isFieldDisabled('identificationNumberFirst')"
                   name="identificationNumberLast"
                   #identificationNumberLast="ngModel">
          </div>
        </div>
        <validation-message [control]="identificationNumberFirst"></validation-message>
      </div>
    </div>

    <!--Tem nif portugues?-->
    <!--<div class="col-sm-4" *ngIf="false">
      <div class="form-group">
        <fieldset [disabled]="isFieldDisabled('hasNIFPT')">
          <label for="hasPortugueseNif" [class.disabled]="isFieldDisabled('hasNIFPT')">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryList.Fields.HasPortugueseNif' | translate}}
          </label>
          <div class="btn-group btn-group-toggle maxWidth">
            <label *ngFor="let domain of yesNo.slice().reverse()" class="btn btn-toogle"
                   [class.active]="domain.value==model.hasNIFPT?.toString()"
                   [radioLabel]="hasPortugueseNif">
              <input type="radio"
                     [(ngModel)]="model.hasNIFPT"
                     name="hasPortugueseNif"
                     #hasLegalRepresentation="ngModel"
                     [value]="domain.value">
              {{domain.description}}
            </label>
            <validation-message [message]="'ValidationMessages.required' | translate"></validation-message>
          </div>
        </fieldset>
      </div>
    </div>-->

    <!--NIF-->
    <div class="col-sm-4">
      <div class="form-group">
        <fieldset [disabled]="!(model.hasNIFPT?.toString()==='true') || isFieldDisabled('NIF')">
          <label for="NIF" [class.disabled]="!(model.hasNIFPT?.toString()==='true') || isFieldDisabled('NIF')">
            <span class="mandatory">*</span>
            {{'PrestacoesMorte.StepBeneficiary.Cards.BeneficiaryListTable.BeneficiaryIdentification.Fields.NIF' | translate}}
          </label>
          <input class="form-control"
                 type="number"
                 numeric="9"
                 [(ngModel)]="model.NIF"
                 name="NIF"
                 #NIF="ngModel"
                 maxlength="9"
                 nifValidation
                 [required]="model.hasNIFPT?.toString()==='true'">
          <validation-message [control]="NIF"></validation-message>
        </fieldset>
      </div>
    </div>



  </div>



  <!--<div class="row">
    <div class="form-group text-secondary col-sm-12" style="font-size:90%;">
      <label style="display:block">
        {{'PrestacoesMorte.StepSender.Cards.SenderIdentification.Messages.PersonalData' | translate}}
      </label>
    </div>
  </div>-->
</main>
